import React, { useState } from 'react';
import { connect } from 'react-redux';
import { Modal, Button, Checkbox } from 'semantic-ui-react';
import * as ACTIVATION_RULES from '../../../actions/activationRulesActions';

// Constants
const QUESTION_TYPES = {
    YES_NO: 'yes_no',
    SINGLE_CHOICE: 'mc_sel_one',
    MULTI_SELECT: 'multi_select'
};

const YES_NO_OPTIONS = [
    { value: 'Yes', positive: true },
    { value: 'No', negative: true }
];

// Utility Functions
const parseLookupValue = (lookup) => {
    const valuesArray = JSON.parse(lookup[0].values);
    const lookupValues = valuesArray.map((valueObj) => valueObj.value);
    return {
        ...lookup,
        values: lookupValues,
    };
};

const createQuestionWithAnswers = (question, selectedAnswers) => ({
    questionId: question.id,
    question: question.question,
    questionnaireId: question.questionaireId,
    tenantId: question.tenantId,
    answers: selectedAnswers.map(answer => ({ value: answer })),
});

const QuestionModal = (props) => {
    const { question, lookupValue, onClose, onSave } = props;
    const [selectedAnswers, setSelectedAnswers] = useState([]);

    const parsedLookupValue = question.questionType !== QUESTION_TYPES.YES_NO
        ? parseLookupValue(lookupValue)
        : null;

    const handleSave = () => {
        const questionWithAnswers = createQuestionWithAnswers(question, selectedAnswers);
        onSave(JSON.stringify([questionWithAnswers]));
        onClose();
    };

    const handleAnswerClick = (answer) => {
        switch (question.questionType) {
            case QUESTION_TYPES.SINGLE_CHOICE:
            case QUESTION_TYPES.YES_NO:
                setSelectedAnswers([answer]);
                break;
            case QUESTION_TYPES.MULTI_SELECT:
                setSelectedAnswers(prevAnswers =>
                    prevAnswers.includes(answer)
                        ? prevAnswers.filter(selectedAnswer => selectedAnswer !== answer)
                        : [...prevAnswers, answer]
                );
                break;
            default:
                break;
        }
    };

    const renderYesNoButtons = () => (
        <>
            {YES_NO_OPTIONS.map(option => (
                <Button
                    key={option.value}
                    onClick={() => handleAnswerClick(option.value)}
                    positive={option.positive && selectedAnswers.includes(option.value)}
                    negative={option.negative && selectedAnswers.includes(option.value)}
                >
                    {option.value}
                </Button>
            ))}
        </>
    );

    const renderLookupOptions = () => (
        <div>
            {parsedLookupValue?.values.map((value, index) => (
                <div key={index} style={{ marginBottom: '10px' }}>
                    <Checkbox
                        radio={question.questionType === QUESTION_TYPES.SINGLE_CHOICE}
                        label={value}
                        checked={selectedAnswers.includes(value)}
                        onChange={() => handleAnswerClick(value)}
                    />
                </div>
            ))}
        </div>
    );

    return (
        <Modal open={true} size="small">
            <Modal.Header>
                <span style={{ fontWeight: 'bold' }}>Select an answer for:</span> "{question.question}"
            </Modal.Header>
            <Modal.Content>
                {question.questionType === QUESTION_TYPES.YES_NO
                    ? renderYesNoButtons()
                    : renderLookupOptions()
                }
            </Modal.Content>
            <Modal.Actions>
                <Button negative onClick={onClose}>
                    Cancel
                </Button>
                <Button positive onClick={handleSave} disabled={!selectedAnswers.length}>
                    Save
                </Button>
            </Modal.Actions>
        </Modal>
    );
};

const mapStateToProps = (state) => ({
    tenant: state.tenantManagement.activeTenant,
});

export default connect(
    mapStateToProps,
    (dispatch) => ({
        fetchLookups: (question) => dispatch(ACTIVATION_RULES.fetchLookupsAction(question)),
    })
)(QuestionModal);
